var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "modalCreateCalculationProductionPosts",
        title: "Показывать в таблице должности",
        centered: "",
        "hide-footer": "",
        "hide-header": "",
      },
      on: {
        close: function ($event) {
          _vm.localActive = false
        },
      },
      model: {
        value: _vm.localActive,
        callback: function ($$v) {
          _vm.localActive = $$v
        },
        expression: "localActive",
      },
    },
    [
      _c("div", { staticClass: "m-posts" }, [
        _c(
          "svg",
          {
            staticClass: "m-posts-close",
            attrs: {
              width: "15",
              height: "16",
              viewBox: "0 0 15 16",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
            },
            on: {
              click: function ($event) {
                _vm.localActive = false
              },
            },
          },
          [
            _c("path", {
              attrs: {
                d: "M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z",
                fill: "#8E9CBB",
              },
            }),
            _c("path", {
              attrs: {
                d: "M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z",
                fill: "#8E9CBB",
              },
            }),
          ]
        ),
        _c("div", { staticClass: "m-posts-title" }, [
          _vm._v("Показывать в таблице должности:"),
        ]),
        _c(
          "div",
          { staticClass: "m-posts-search" },
          [
            _c("c-input", {
              staticClass: "m-posts-search-input",
              attrs: {
                placeholder: "Поиск по должностям",
                icon: "search",
                "placeholder-style": "italic",
                clearable: "",
              },
              model: {
                value: _vm.search,
                callback: function ($$v) {
                  _vm.search = $$v
                },
                expression: "search",
              },
            }),
          ],
          1
        ),
        _c("div", { staticClass: "position-relative" }, [
          _c("div", {
            staticClass: "m-posts-content-shadow-top",
            attrs: { id: "m-posts-content-shadow-top" },
          }),
          _c(
            "div",
            {
              staticClass: "m-posts-content",
              attrs: { id: "m-posts-content" },
              on: { scroll: _vm.setShadowsOnScroll },
            },
            [
              _c(
                "div",
                { staticClass: "m-posts-content-result" },
                [
                  _vm._l(_vm.postsLocal, function (post) {
                    return [
                      post.isVisible
                        ? _c("c-switcher", {
                            key: post.name,
                            staticClass: "m-posts-content-result-item",
                            attrs: { type: "checkbox", label: post.name },
                            model: {
                              value: post.isActive,
                              callback: function ($$v) {
                                _vm.$set(post, "isActive", $$v)
                              },
                              expression: "post.isActive",
                            },
                          })
                        : _vm._e(),
                    ]
                  }),
                ],
                2
              ),
              !_vm.postsLocal.some((post) => post.isVisible)
                ? _c("div", { staticClass: "m-posts-content-empty" }, [
                    _vm._v(" Должности не найдены "),
                  ])
                : _vm._e(),
            ]
          ),
          _c("div", {
            staticClass: "m-posts-content-shadow-bottom",
            attrs: { id: "m-posts-content-shadow-bottom" },
          }),
        ]),
        _c(
          "div",
          { staticClass: "m-posts-actions" },
          [
            _c("c-button", {
              staticClass: "m-posts-actions-reset",
              attrs: { size: "large", label: "Сбросить" },
              on: {
                click: function ($event) {
                  return _vm.reset()
                },
              },
            }),
            _c("c-button", {
              staticClass: "m-posts-actions-apply",
              attrs: { label: "Применить", color: "blue", size: "large" },
              on: {
                click: function ($event) {
                  return _vm.submitPosts()
                },
              },
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }